'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasShiftKey = exports.hasCommandModifier = exports.isControlKeyCommand = undefined;

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _browser = require('../services/browser');

var _dragModifierKeysConstants = require('../dnd/modifierKeys/dragModifierKeysConstants');

/**
 * True if the control key is being pressed.
 */
var isControlKeyCommand = exports.isControlKeyCommand = function isControlKeyCommand(eventKeys) {
  return !!(0, _immutableHelper.prop)(_dragModifierKeysConstants.MODIFIER_KEYS.ctrlKey, eventKeys);
};

/**
 * Determines if the 'command modifier' is being used.  I.e. The 'command' key for macs, or the 'control' key for
 * others.
 *
 * @param eventKeys {Object} A key map containing boolean flags denoting if the key is pressed.
 *      E.g:  { metaKey: false, shiftKey: false, ctrlKey: true, ... }
 *
 *      This could also be a keyboard event object.
 * @return {Boolean} True if the 'command' key is being held and the platform is a mac, or the 'control' key is being
 *      held down for other platforms.
 */


// Constants
// Utils
var hasCommandModifier = exports.hasCommandModifier = function hasCommandModifier(eventKeys) {
  return _browser.isApple ? !!(0, _immutableHelper.prop)(_dragModifierKeysConstants.MODIFIER_KEYS.metaKey, eventKeys) : isControlKeyCommand(eventKeys);
};

var hasShiftKey = exports.hasShiftKey = function hasShiftKey(eventKeys) {
  return eventKeys && (0, _immutableHelper.prop)(_dragModifierKeysConstants.MODIFIER_KEYS.shiftKey, eventKeys);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/keyboard/keyboardUtility.js
// module id = 313
// module chunks = 0